export default function MaintenancePage(props) {
  return (
    <div style={styles.body}>
      <div style={styles.banner}>CABIE-ENS Maintenance</div>
      <div style={styles.container}>
        <h1 style={styles.heading}>System Maintenance</h1>
        {/* <p style={styles.text}>
                    Please note we will be undertaking planned maintenance on <b>Friday 7th February 2025</b> starting at <b>18:00 PM GMT/BST</b> for up to <b>1 hour</b>. <br />
                    We appreciate your patience.
                </p> */}
        <p style={styles.text}>{props.maintenanceMessage}</p>
      </div>
    </div>
  );
}

const styles = {
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    margin: '0',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#1976d2',
    textAlign: 'center',
    position: 'relative',
  },
  banner: {
    position: 'absolute',
    top: '0',
    width: '100%',
    backgroundColor: '#1976d2',
    color: 'white',
    textAlign: 'center',
    padding: '15px 0',
    fontSize: '34px',
    fontWeight: 'bold',
  },
  container: {
    background: 'white',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  },
  heading: {
    color: '#333',
    textAlign: 'center',
  },
  text: {
    color: '#666',
    fontSize: '20px',
    marginTop: '20px',
    whiteSpace: 'pre-wrap',
  },
};
